import * as Enumerable from "linq";
import { MepYearOverYearStatisticModel } from "../../../../../../../../models/mep/mep-year-on-year.models";
import { useView } from "aurelia-framework";

@useView('views/pages/modules/mep/tabs/mep-year-over-year-comparison/partials/mep-year-over-year-statistic-item/mep-year-over-year-statistic-item.html')
export class MepYearOverYearStatisticItem {
    statisticsByYear: {
        year: number,
        percentageOfAllYears: number,
        percentageFromBaseYear: number,
        isBaseYear: boolean;
        count: number
    }[] = [];
    baseYear = 0;

    getYearColor: (year: number) => string;

    constructor(public title: string, public icon: string,
        private getBarValue: (statistic: MepYearOverYearStatisticModel) => number,
        private getPercentageChangeValue: (statistic: MepYearOverYearStatisticModel) => number,
        getYearColorFunc: (year: number) => string) {
            this.getYearColor = getYearColorFunc;
    }

    public setBaseYear(year) {
        this.baseYear = year;
    }

    public refreshData(statistics: MepYearOverYearStatisticModel[]) {
        if (statistics && statistics.length > 0) {
            const statisticsQuery = Enumerable.from(statistics);
            const summedValuesByYear = statisticsQuery.groupBy(x => x.year).select(x => {
                return {
                    year: x.key(),
                    totalInYear: x.sum(this.getBarValue)
                };
            });
            const maxTotalInYear = summedValuesByYear.max(x => x.totalInYear);
            const data = statisticsQuery.groupBy(x => x.year).select(x => {
                const yearValue = summedValuesByYear.first(y => y.year == x.key());
                return {
                    year: x.key(),
                    percentageOfAllYears: (yearValue.totalInYear / (maxTotalInYear == 0 ? 1 : maxTotalInYear)) * 100,
                    percentageFromBaseYear: this.getPercentageChangeValue(x.first()),
                    isBaseYear: x.key() == this.baseYear,
                    count: yearValue.totalInYear
                };
            }).toArray().sort((x) => { // this to ensure base year is first 
                return x && x.year == this.baseYear ? -1 : 1;
            });
            this.statisticsByYear = data;
        }
    }
    
    public getAbsPercentage(statByYearPercentage: number) {
        if (!statByYearPercentage)
            return statByYearPercentage;

        return Math.abs(statByYearPercentage);
    }
}